/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsByDateDto } from '../../models/submissions-by-date-dto';

export interface FactorSubmissionsClientByBlockGet$Plain$Params {
  aggregationType?: string;
  clientName?: string;
  fromDate?: string;
  toDate?: string;
}

export function factorSubmissionsClientByBlockGet$Plain(http: HttpClient, rootUrl: string, params?: FactorSubmissionsClientByBlockGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsByDateDto>>> {
  const rb = new RequestBuilder(rootUrl, factorSubmissionsClientByBlockGet$Plain.PATH, 'get');
  if (params) {
    rb.query('aggregationType', params.aggregationType, {});
    rb.query('clientName', params.clientName, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsByDateDto>>;
    })
  );
}

factorSubmissionsClientByBlockGet$Plain.PATH = '/Factor/submissions-client-by-block';
